import { useContext } from 'react'
import { MobXContext } from '../context/mobx'

const useStore = () => useContext(MobXContext)

export default useStore
